const APP_ENV =
  process.env.REACT_APP_ENV ||
  (process.env.NODE_ENV === "production" ? "production" : "local");

const API_BASE_URL_BY_ENV = {
  local: "http://localhost/api/v0/",
  staging: "https://api.johnedgecamelcase.com/api/v0/",
  production: "https://api.cogitofund.com/api/v0/",
};

const WS_BASE_URL_BY_ENV = {
  local: "ws://localhost/ws/",
  staging: "wss://api.johnedgecamelcase.com/ws/",
  production: "wss://api.cogitofund.com/ws/",
};

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  API_BASE_URL_BY_ENV[APP_ENV] ||
  API_BASE_URL_BY_ENV.local;

export const WS_BASE_URL =
  process.env.REACT_APP_WS_BASE_URL ||
  WS_BASE_URL_BY_ENV[APP_ENV] ||
  WS_BASE_URL_BY_ENV.local;

export const buildWsUrl = (path, queryParams = {}) => {
  const normalizedPath = String(path || "")
    .replace(/^\/+/, "")
    .replace(/^ws\//, "");
  const url = new URL(normalizedPath, WS_BASE_URL);

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
};
